import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { atom, useRecoilState } from 'recoil';
import { MapDrawerEntityForPoi } from 'shared/types';

type MapDrawerEntityForPoiState = {
  mapDrawerEntityForPoi: MapDrawerEntityForPoi | null;
};

type UseMapDrawerEntityForPoiState = {
  mapDrawerEntityForPoi: MapDrawerEntityForPoi | null;
  setMapDrawerEntityForPoi: (
    mapDrawerEntityForPoi: MapDrawerEntityForPoi | null,
  ) => void;
};

const DEFAULT_MAP_DRAWER_ENTITY_STATE: MapDrawerEntityForPoiState = {
  mapDrawerEntityForPoi: null,
};

export const mapDrawerEntityAtom = atom({
  key: 'DEFAULT_MAP_DRAWER_ENTITY_STATE',
  default: DEFAULT_MAP_DRAWER_ENTITY_STATE,
});

/**
 * Custom hook that manages map drawer entity state for POIs.
 * Other map entities' states (e.g., geoevents, alert cameras) are handled by the router.
 */
export const useMapDrawerEntityForPoiState =
  (): UseMapDrawerEntityForPoiState => {
    const [mapDrawerEntityForPoiState, setMapDrawerEntityForPoiState] =
      useRecoilState(mapDrawerEntityAtom);
    const history = useHistory();

    const setMapDrawerEntityForPoi = useCallback(
      (mapDrawerEntityForPoi: MapDrawerEntityForPoi | null) => {
        if (mapDrawerEntityForPoi && history.location.pathname !== '/') {
          history.push('/');
        }
        setMapDrawerEntityForPoiState({ mapDrawerEntityForPoi });
      },
      [history, setMapDrawerEntityForPoiState],
    );

    return {
      mapDrawerEntityForPoi: mapDrawerEntityForPoiState.mapDrawerEntityForPoi,
      setMapDrawerEntityForPoi,
    };
  };
